import { Euro, X } from 'lucide-react';
import type { MapaMesa } from '../../types';

export interface OcuparFormState {
  numeroPessoas: number;
  valor: number;
  contatoReserva: string;
  notasMesa: string;
  clienteId: number | undefined;
  nomeCliente: string;
}

interface OcuparMesaModalProps {
  mesa: MapaMesa;
  form: OcuparFormState;
  saving: boolean;
  onChange: (patch: Partial<OcuparFormState>) => void;
  onClose: () => void;
  onSubmit: (e: React.FormEvent) => void;
}

export function OcuparMesaModal({ mesa, form, saving, onChange, onClose, onSubmit }: OcuparMesaModalProps) {
  return (
    <div className="modal-overlay" role="dialog" aria-modal="true">
      <div className="modal">
        <header className="modal-header">
          <h2 className="modal-title">
            Ocupar Mesa {mesa.numero} — {mesa.descricao}
          </h2>
          <button className="modal-close" onClick={onClose} aria-label="Fechar">
            <X className="w-5 h-5" />
          </button>
        </header>
        <form onSubmit={onSubmit} className="modal-body">
          <div className="form-row" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, alignItems: 'end' }}>
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label className="label" style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                Nº pessoas *
              </label>
              <input
                type="number"
                className="input"
                value={form.numeroPessoas}
                onChange={(e) => onChange({ numeroPessoas: Number(e.target.value) || 1 })}
                min={1}
                max={20}
                required
              />
            </div>
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label className="label" style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <Euro className="w-4 h-4" />
                Valor (€)
              </label>
              <input
                type="number"
                className="input"
                value={form.valor}
                onChange={(e) => onChange({ valor: Number(e.target.value) || 0 })}
                min={0}
                step={0.01}
                placeholder="0.00"
              />
            </div>
          </div>
          <div className="form-group">
            <label className="label">Contacto</label>
            <input
              className="input"
              value={form.contatoReserva}
              onChange={(e) => onChange({ contatoReserva: e.target.value })}
              placeholder="Telefone"
            />
          </div>
          <div className="form-group">
            <label className="label">Notas</label>
            <textarea
              className="input"
              rows={2}
              value={form.notasMesa}
              onChange={(e) => onChange({ notasMesa: e.target.value })}
              placeholder="Observações"
            />
          </div>
        </form>
        <footer className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            Cancelar
          </button>
          <button className="btn btn-primary" onClick={onSubmit} disabled={saving}>
            {saving ? 'A guardar...' : 'Ocupar'}
          </button>
        </footer>
      </div>
    </div>
  );
}
